import React from 'react';
import headerUnderline from '../assets/figma/header-underline.svg';

const skillGroups = [
  { title: 'Programming', skills: ['Python', 'Java', 'SQL', 'JavaScript', 'React'] },
  { title: 'Cloud & Infra', skills: ['AWS EC2', 'S3', 'Glue', 'Athena', 'Kafka'] },
  { title: 'Data', skills: ['Pandas', 'NumPy', 'Matplotlib', 'Seaborn', 'Scikit-learn', 'ETL'] },
  { title: 'Backend', skills: ['Flask', 'REST APIs', 'Node.js'] },
  { title: 'Testing', skills: ['BDD', 'Cucumber', 'TestNG', 'Appium'] },
  { title: 'Tools', skills: ['Git', 'Jira', 'Postman', 'VS Code'] },
];

const Skills = () => (
  <section className="skills-section" id="skills-section">
    <div className="skills-content">
      <header className="skills-header">
        <div className="skills-kicker">
          <span className="skills-kicker-dot" />
          <span>Technical Skills</span>
        </div>
        <h2>My Toolkit</h2>
        <img className="skills-underline" src={headerUnderline} alt="" aria-hidden="true" />
      </header>

      <div className="skills-grid">
        {skillGroups.map((group) => (
          <article className="skill-group" key={group.title}>
            <h3>{group.title}</h3>
            <div className="skill-tags">
              {group.skills.map((skill) => <span key={skill}>{skill}</span>)}
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default Skills;
